module.exports = __webpack_public_path__ + "static/media/pattern.c4113510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pattern.png
// module id = 519
// module chunks = 110